export default {
  usingAppraiseDetail: {
    component: () =>
      import(
        /* webpackChunkName: "transfer_detail" */ "../usingAppraise/detailView/UsingAppraiseDetail"
      ),
  },
};
